import React from 'react';
import FilterList from '~/popups/CourseList/FilterList';
import CourseNav from '~/popups/CourseList/CourseNav';
import CourseTitle from '~/popups/CourseList/CourseTitle';
import CourseContent from '~/popups/CourseList/CourseContent';

// Metrika
import metrikaId from '~/helpers/metrika';
import metrikaGoal from '~/helpers/metrikaGoal';
import analyticsWidgetsUsing from '~/helpers/analyticsWidgetsUsing';

// data
import { fakeData, fakeTags } from './fakeData';

// components
import PopupClose from '../../components/popups/Close';
import ChildrenCourseNav from './ChildrenCourseNav';

class CourseList extends React.Component {
  constructor(props) {
    super(props);

    if (props.filters && process.env.NODE_ENV != 'development') {
      analyticsWidgetsUsing('Тэги');
    }

    this.state = {
      width: null,
      current: null,
      currentChild: null,
      content: [],
      filters: props.filters ? props.filters.split(',') : [],
      alltags: {},
    };
  }

  componentDidMount() {
    const content = window.navmenu ? window.navmenu : fakeData;
    const current = $(document).width() < 1280 ? null : content[0].id;
    let alltags = {};
    if (process.env.NODE_ENV === 'development') {
      alltags = fakeTags;
    } else {
      alltags = window.tags ? window.tags : fakeTags;
      metrikaGoal('scenario-menu-open');
      analyticsWidgetsUsing('Меню курсов');
    }

    window.addEventListener('resize', this.resizeHandler.bind(this));

    this.setState({ content, current, alltags });
  }

  resizeHandler() {
    this.setState({width: window.innerWidth});
  }

  sortContent(content) {
    if (!content) return  [];

    content.forEach(item => this.sortContent(item.children));

    return content.sort((first, second) => {
      if (first.sort === second.sort) return 0;
      return parseInt(first.sort) < parseInt(second.sort) ? -1 : 1;
    });
  }

  getFilteredContent() {
    const { content, current, filters } = this.state;

    // If have filters - ignore selected current tab
    if (filters.length) {
      const filtered = [];
      // Check parents with childrens
      content
        .filter(c => {
          return c.children.length;
        })
        .forEach(parent => {
          // Iterate every child
          parent.children.forEach(child => {
            // If element has tags, selected in filters
            if (
              child.tag &&
              child.tag.filter(t => filters.indexOf(t) > -1).length
            ) {
              filtered.push(child);
            }
            // If element has children - check them
            if (child.children.length) {
              child.children.forEach(subchild => {
                if (subchild.tag.filter(t => filters.indexOf(t) > -1).length) {
                  filtered.push(subchild);
                }
              });
            }
          });
        });
      return filtered;
    }

    const currentParent = content.filter(c => c.id == current).pop();
    const childContent = currentParent ? currentParent.children : [];

    return childContent;
  }

  getFilteredContentByTags() {
    const { content, filters } = this.state;
    const haveChildrenWithTags = [];
    // items with children with tags
    content.forEach(item => {
      if (item.children.length && item.children[0].tag) {
        haveChildrenWithTags.push(item);
      }
      item.children.forEach(it => {
        if (it.children.length && it.children[0].tag) {
          haveChildrenWithTags.push(it);
        }
      });
    });

    // filtered by tags (filters)
    return haveChildrenWithTags
      .map(item => ({
        ...item,
        children: item.children.filter(child => {
          let returned = false;
          if (child.tag) {
            child.tag.forEach(t => {
              returned = returned || filters.indexOf(t) !== -1;
            });
          }
          return returned;
        })
      }))
      .filter(item => !!item.children.length);
  }

  getFilteredContentByChild() {
    const { content, current, currentChild } = this.state;

    const currentItem = content.find(item => item.id === current);
    return currentItem ? [currentItem.children.find(childItem => childItem.id === currentChild)] : [];
  }

  updateFilters(filter) {
    const { filters, content } = this.state;
    const indexOf = filters.indexOf(filter);
    let newFilters = [...filters];
    if (indexOf === -1) {
      newFilters.push(filter);
    } else {
      newFilters = newFilters.filter(f => f !== filter);
    }

    analyticsWidgetsUsing('Тэги');

    const current = $(document).width() < 1280 ? null : content[0].id;
    this.setState({ filters: newFilters, current });
    if (!newFilters.length) {
      this.setState({currentChild: null});
    }
  }

  resetFilters() {
    const {content} = this.state;
    this.setState({filters: []});
    const current = $(document).width() < 1280 ? null : content[0].id;
    this.setState({current});
    this.setState({currentChild: null});
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler.bind(this));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {width, current, content} = this.state;
    if (prevState.width !== width) {
      if (width >= 1280 && !current) {
        this.setState({current: content[0].id});
      }
    }
  }

  render() {
    const { current, currentChild, content, filters, alltags } = this.state;

    const classes = ['popup-nav__wrapper'];
    if (filters.length) classes.push('popup-nav__wrapper--hidetabs');
    if (current || filters.length) classes.push('popup-nav__wrapper--selected');

    const filteredContent = !!filters.length
      ? this.getFilteredContentByTags()
      : currentChild
        ? this.getFilteredContentByChild()
        : this.getFilteredContent();
    const sortedContent = this.sortContent(filteredContent);

    return (
      <div className="popup popup-message popup-nav">
        <div className="popup__close-container"><PopupClose/></div>
        <CourseTitle
          content={content}
          current={current}
          onBack={() => this.setState({ current: null })}
        />
        <FilterList
          onChange={filter => this.updateFilters(filter)}
          alltags={alltags}
          filters={filters}
          resetFilters={() => this.resetFilters()}
        />
        <ChildrenCourseNav
          current={current}
          currentChild={currentChild}
          content={content}
          onChildChange={newTargetChild => this.setState({currentChild: newTargetChild})}
          onChange={newTarget => {
            this.setState({ current: newTarget });
            this.setState({currentChild: null});
          }}
        />
        <div className={classes.join(' ')}>
          <CourseNav
            current={current}
            currentChild={currentChild}
            content={content}
            onChange={newTarget => {
              this.setState({ current: newTarget });
              this.setState({currentChild: null});
            }}
            onChildChange={newTargetChild => this.setState({currentChild: newTargetChild})}
          />
          <CourseContent content={sortedContent} />
        </div>
      </div>
    );
  }
}

export default CourseList;
